/**
 * Specifies the release mode for preloaded media segments in the player.
 *
 * @remarks
 * This enum is used to determine when preloaded segments should be released
 * during the player's lifecycle.
 *
 * @enum {number}
 * @property {RELEASE_ON_PLAYER_READY} Release preloaded segments when the player is ready.
 * @property {RELEASE_ON_INITIAL_SEGMENTS_LOAD} Release preloaded segments after the initial segments are loaded.
 */
export enum PreloadReleaseMode {

    RELEASE_ON_PLAYER_READY = 0,
    RELEASE_ON_INITIAL_SEGMENTS_LOAD = 1

}